parseTokenHHMM